export function renderMarquee() {
  const renderTrack = () => `
    <span class="mx-6 text-white font-semibold">CODE</span>
    <span class="text-neutral-600">✦</span>
    <span class="mx-6 text-cyan-telemetry font-semibold">WEB</span>
    <span class="text-neutral-600">✦</span>
    <span class="mx-6 text-white font-semibold">GRAPHICS</span>
    <span class="text-neutral-600">✦</span>
    <span class="mx-6 text-amber-200 font-semibold">GAME DEV</span>
    <span class="text-neutral-600">✦</span>
    <span class="mx-6 text-white font-semibold">SYSTEMS</span>
    <span class="text-neutral-600">✦</span>
    <span class="mx-6 border border-[#E06D44]/50 bg-[#E06D44]/10 px-2.5 py-0.5 text-amber-200 font-semibold">SHADERS</span>
    <span class="text-neutral-600">✦</span>
    <span class="mx-6 text-neutral-300 font-semibold">EXPERIMENTS</span>
    <span class="text-neutral-600">✦</span>
  `;

  return `
    <div class="border-y border-[#1C201E] bg-[#050505] py-3.5 overflow-hidden select-none relative z-20">
      <div class="flex whitespace-nowrap animate-marquee font-mono text-xs tracking-[0.28em] uppercase">
        <div class="flex items-center">
          ${renderTrack()}
          ${renderTrack()}
        </div>
        <div class="flex items-center" aria-hidden="true">
          ${renderTrack()}
          ${renderTrack()}
        </div>
      </div>
    </div>
  `;
}
